import LOCATIONS from "@/data/locations.yml";
import ContentBlock from "@/components/content-block";
import Hotspot from "@/components/Hotspot";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  components: { ContentBlock, Hotspot },
  data() {
    return {
      LOCATIONS,
    };
  },
};
